import { registerPlugin } from '@capacitor/core';

/**
 * Native Android immersive mode. Hides the system bars so a fullscreen video's
 * controls are not overlapped by them. Android only; a no-op elsewhere.
 */
export interface ImmersiveModePlugin {
  enable(): Promise<void>;
  disable(): Promise<void>;
}

export const ImmersiveMode = registerPlugin<ImmersiveModePlugin>('ImmersiveMode');
